<!-- Template for the action button that parent component can render -->
<ng-template #actionButton>
  <iris-button
    id="pendo-basic-info-submission"
    (click)="submitBasicInfo()"
    [disabled]="isSubmitDisabled"
    data-test="profile-next-button-text"
  >
    Next
  </iris-button>
</ng-template>

@if (fromDirectBooking()) {
  <div class="preamble">
    <h1 class="heading">You're nearly there</h1>
    <p class="edit-profile-insurance-message iris-mb-04">
      Confirm and complete the info below and then continue to your insurance and payment to finish booking your session.
    </p>
  </div>
}
<div class="container">
  <div [class.from-direct-booking]="fromDirectBooking()">
    <client-profile-edit-form
      #profileEditForm
      [useInSessionRequest]="useInSessionRequest()"
      [isProposeATime]="isProposeATime()"
      [isMobile]="isMobile()"
      [accountComplete]="false"
      (basicInfoFirstSubmit)="profileInfoSubmitted()"
      [fromDirectBooking]="fromDirectBooking()"
    ></client-profile-edit-form>

    @if (!tosModalEnabled()) {
      <client-setup-attestation-agree
        #attestationAgree
        (attestationsSubmitted)="attestationsSubmitted()"
      ></client-setup-attestation-agree>
    }

    @if (!fromDirectBooking()) {
      <iris-button-container [alignment]="irisButtonContainerAlignments.END">
        <ng-container *ngTemplateOutlet="actionButton"></ng-container>
      </iris-button-container>
    }
  </div>
</div>
